import Tooltip from '../common/Tooltip'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

/**
 * Controlled targetgroup-filter chip for effect cards. Has no internal state —
 * caller owns the selected ID and decides what `onChange` does (local React
 * state in analytics, Firestore write in dashboard).
 *
 * When there is exactly one targetgroup the chip renders as a non-interactive
 * label (no select).
 *
 * @param {object} props
 * @param {Array<{ID: string, Organisation: string}>} props.targetgroups - Selectable targetgroups. Renders nothing when empty.
 * @param {string} [props.selectedTargetgroupId] - Currently selected targetgroup ID, or '' / falsy for "all".
 * @param {(newId: string) => void} props.onChange - Called with the new targetgroup ID (or '' for "all").
 * @param {boolean} [props.multipleQuestionnaires] - When true, shows an info tooltip explaining cross-questionnaire aggregation.
 */
const DashboardEffectTargetgroupFilter = ({
    targetgroups,
    selectedTargetgroupId,
    onChange,
    multipleQuestionnaires,
}) => {
    if (!Array.isArray(targetgroups) || targetgroups.length === 0) return null

    const handleChange = (e) => {
        onChange(e.target.value)
    }

    if (targetgroups.length === 1) {
        return (
            <span className="dashboard-filter-chip dashboard-filter-chip-static">
                <GroupsOutlinedIcon fontSize="small" className="dashboard-filter-chip-icon" />
                <span className="dashboard-filter-chip-label">Doelgroepen:</span>
                <span className="dashboard-filter-chip-value">{targetgroups[0].Organisation}</span>
            </span>
        )
    }

    return (
        <label className="dashboard-filter-chip">
            <GroupsOutlinedIcon fontSize="small" className="dashboard-filter-chip-icon" />
            <span className="dashboard-filter-chip-label">Doelgr.:</span>
            <select
                className="dashboard-filter-chip-select"
                value={selectedTargetgroupId || ''}
                onChange={handleChange}
            >
                <option value="">Alle</option>
                {targetgroups.map((tg) => (
                    <option key={tg.ID} value={tg.ID}>{tg.Organisation}</option>
                ))}
            </select>
            {multipleQuestionnaires && (
                <Tooltip
                    content="Dit effect komt in meerdere vragenlijsten voor. Alle bijhorende onderzoeken worden meegenomen."
                    top="-60px"
                    width="240px"
                >
                    <InfoOutlinedIcon className="dashboard-filter-chip-info" fontSize="small" />
                </Tooltip>
            )}
        </label>
    )
}

export default DashboardEffectTargetgroupFilter
